import { Box, Typography, Grid, Container, Button } from "@mui/material";
import { coachexp } from "../../assets";
import { useNavigate } from "react-router-dom";

const services = [
    {
        title: "Luxury Sales Mastery Coaching",
        desc: "We empower Real Estate Developers and Sales Teams to navigate high-ticket conversations with absolute clarity and confidence. Our coaching is built on real-world execution and psychology, transforming team mindsets to communicate concise value and master the art of the luxury close.",
        image: coachexp,
        link: "/services/luxury-sales-coach",
    },
    {
        title: "Luxury Sales Consulting",
        desc: "We partner with Real Estate Developers as strategic consultants to manage and support premium high-ticket inventory. From sales strategy and on-ground execution to aligning the project story with the right audience, we ensure consistent cash flows through optimized, end-to-end sales systems",
        image: "https://dprstorage.b-cdn.net/RW/projects/promenade.png",
        link: "/services/luxury-sales-consulting",
    },

];

const ServicesSection = () => {
    const navigate = useNavigate();
    return (
        <Box
            sx={{
                py: 12,

                background: "transparent",
                color: "#fff",
            }}
        >
            <Container maxWidth='lg'>

                {/* HEADING */}
                <Typography
                    variant="h3"
                    textAlign="center"
                    sx={{
                        // fontSize: { xs: "2rem", md: "3rem" },
                        letterSpacing: "4px",
                        mb: 4,
                        color: 'white'
                    }}
                >
                    OUR SERVICES
                </Typography>
                <Typography
                    variant="body2"
                    textAlign="center"
                    sx={{
                
                        mb: 1,
                        color: 'white'
                    }}
                >
                    We support sales growth in two ways by Upskilling & Enabling Sales Professionals and Creating a Sales Mindset, by Luxury Sales Mastery Coaching and by executing Luxury Sales Consulting for Builders & Developers & Multiple Industries.
                </Typography>
                <Typography
                    variant="body2"
                    textAlign="center"
                    sx={{
                       
                        mb: 8,
                        color: 'white'
                    }}
                >
                    Our work is practical, market-driven, and shaped by real world buyer conversations not mere theory.
                </Typography>


                <Grid container spacing={4}>
                    {services.map((item, index) => (
                        <Grid item xs={12} md={6} key={index}>
                            <Box
                                sx={{
                                    position: "relative",
                                    height: { xs: "260px", md: "350px" },
                                    borderRadius: "20px",
                                    overflow: "hidden",
                                    cursor: "pointer",
                                    textAlign: 'start',

                                    // 🔥 IMAGE
                                    backgroundImage: `url(${item.image})`,
                                    backgroundSize: "cover",
                                    backgroundPosition: "center",

                                    // 🔥 HOVER EFFECT
                                    transition: "all 0.5s ease",
                                    "&:hover": {
                                        transform: "scale(1.03)",
                                    },

                                    // 🔥 DARK GRADIENT OVERLAY
                                    "&::before": {
                                        content: '""',
                                        position: "absolute",
                                        inset: 0,
                                        background:
                                            "linear-gradient(135deg, rgba(15, 99, 165, 0.8) 0%, rgba(10, 22, 40, 0.95) 100%)",
                                        zIndex: 1,
                                    },
                                }}
                            >
                                {/* 🔥 TEXT CONTENT */}
                                <Box
                                    sx={{
                                        // position: "absolute",
                                        // bottom: 20,
                                        // left: 20,
                                        // zIndex: 2,
                                        // p: 3,
                                        position: "absolute",
                                        inset: 0, // 🔥 fills entire card
                                        zIndex: 2,

                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        justifyContent: "center", // 🔥 CENTER VERTICALLY

                                        textAlign: "center",
                                        px: 3,
                                    }}
                                >
                                    <Typography variant="h6" sx={{ color: "#fff", mb: 1 }}>
                                        {item.title}
                                    </Typography>

                                    <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.85)" }}>
                                        {item.desc}
                                    </Typography>

                                    {/* 🔥 BUTTON HERE */}
                                    <Button
                                        onClick={() => navigate(item.link)}
                                        sx={{
                                            mt: 2,
                                            px: 3,
                                            py: 1,
                                            borderRadius: "6px",
                                            background: "rgba(255,255,255,0.05)",
                                            border: "1px solid rgba(255,255,255,0.4)",
                                            color: "#fff",
                                            textTransform: "none",
                                            fontSize: "0.85rem",
                                            letterSpacing: "1px",
                                            backdropFilter: "blur(6px)",
                                            "&:hover": {
                                                background: "#ffffff",
                                                color: "#0f63a5",
                                            },
                                        }}
                                    >
                                        Explore More →
                                    </Button>
                                </Box>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};

export default ServicesSection;